import { useCellIsEditing, useCellIsReadOnly } from '../../cell.hooks'
import { CellFrame } from '../../CellFrame'

import { RichtextColumnCellEditor } from './RichtextColumnCellEditor'
import { RichtextColumnCellPreview } from './RichtextColumnCellPreview'

/**
 * Renders a Cell inside a Column of type `richtext`.
 *
 * It can either render a text preview or text editor.
 */
export function RichtextColumnCell() {
  const isEditing = useCellIsEditing()
  const isReadOnly = useCellIsReadOnly()

  if (isEditing && !isReadOnly) {
    return (
      <CellFrame>
        <RichtextColumnCellEditor />
      </CellFrame>
    )
  }

  return (
    <CellFrame>
      <RichtextColumnCellPreview />
    </CellFrame>
  )
}
